import { render, staticRenderFns } from "./agregarSesion.vue?vue&type=template&id=60e5c9f2&"
import script from "./agregarSesion.vue?vue&type=script&lang=js&"
export * from "./agregarSesion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports